<script>
const sidebarMenu = [
  /*{ path: '/dashboard', icon: 'fab fa-delicious', title: 'Összesítőpult' },
  { path: '/boxes', icon: 'fa fa-user-lock', title: 'Szekrények' },
  { path: '/locks', icon: 'fa fa-lock', title: 'Lakatok' },
  { path: '/system', icon: 'fa fa-cog', title: 'Rendszer',
    children: [
      { path: '/system/users', icon: 'fa fa-users', title: 'Felhasználók'},
    ]
  },*/
  { path: '/bookings', icon: 'fa fa-calendar', title: 'Foglalások', roles:[1,2] },
  { path: '/guesthouses', icon: 'fa-solid fa-house-chimney-user', title: 'Vendégházak', roles:[1] },
  { path: '/prices', icon: 'fa fa-dollar-sign', title: 'Árak', roles:[1] },
  { path: '/news', icon: 'fa fa-solid fa-newspaper', title: 'Hírek', roles:[1] },
  { path: '/coupons', icon: 'fa fa-ticket', title: 'Kuponok', roles:[1] },
  { path: '/emails', icon: 'fa fa-envelope', title: 'Emailek', roles:[1] },
  { path: '/financials', icon: 'fa-solid fa-money-bill', title: 'Pénzügyek', roles:[3] },
  { path: '/transactions', icon: 'fa-solid fa-comments-dollar', title: 'Tranzakciók', roles:[3] },
  { path: '/statistics', icon: 'fa-solid fa-chart-line', title: 'Statisztika', roles:[1,3] },
  { path: '/booking', icon: 'fas fa-calendar-plus', title: 'Foglalás', roles:[10] },
  //{ path: '/test', icon: 'fas fa-calendar-plus', title: 'Teszt', roles:[10] },
  { path: '/profile', icon: 'fa fa-user', title: 'Profilom', roles:[10] },
  { path:  '/base-data',icon:'fa fa-boxes', title: 'Alap adatok', roles:[1],
    children: [
      { path: '/base-data/users', icon: 'fa fa-users', title: 'Felhasználók'},
      { path: '/virtual-api', icon: 'fa fa-globe', title: 'Virtuális API'},
    ]
  },
  { path:  '/settings',icon:'fa fa-cog', title: 'Beállítások', roles:[1,3,2],
    children: [
      { path: '/profile', icon:'fa fa-user', title: 'Személyes', roles:[10]},
      { path: '/profile-admin', icon:'fa fa-user', title: 'Személyes', roles:[1,2,3]},
      { path: '/base-data/settings', icon: 'fa fa-globe', title: 'Rendszer', roles:[1]},
    ]
  },
]

export default sidebarMenu;
</script>
